var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.81 107.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b8aaf;}.cls-2{fill:#db7a27;}.cls-3{fill:#d17732;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.59,74.49h48V12h-48ZM56.26,57.37A10.62,10.62,0,0,0,45.83,68.15h-5.3c0-9,7.06-16.27,15.73-16.27Zm0-10.91c-11.56,0-21,9.73-21,21.69H30C30,53.17,41.77,41,56.26,41Zm0-11.24C38.71,35.22,24.43,50,24.43,68.15h-5.3c0-21.18,16.65-38.41,37.13-38.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.21,79.31h3.09V95h-3.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.89,79.31V95H166.1l-7.84-10.5,0,4.66V95h-3.09V79.31H158l7.84,10.52,0-4.45V79.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.79,93.12l1.61-2.3a8.2,8.2,0,0,0,5.06,1.7c2.09,0,3.41-.78,3.41-2s-1.1-1.81-3.56-2.1c-4.28-.52-6.14-1.95-6.14-4.75S176.73,79,180.42,79a10.11,10.11,0,0,1,5.87,1.88l-1.53,2.2a7.24,7.24,0,0,0-4.25-1.41c-1.95,0-3.29.8-3.29,2s1,1.74,3.45,2.06c4.34.58,6.29,2,6.29,4.79,0,2.93-2.6,4.88-6.5,4.88A10.9,10.9,0,0,1,173.79,93.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.74,79.31h3.1V95h-3.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.54,85.91V92.7A8.72,8.72,0,0,1,208,95.32c-4.95,0-8.2-3.23-8.2-8.17S203.23,79,208.2,79a7.9,7.9,0,0,1,5.91,2.47l-1.92,1.92a5.77,5.77,0,0,0-4-1.63,5,5,0,0,0-5.29,5.42c0,3.29,2,5.42,5.13,5.42a5.68,5.68,0,0,0,3.79-1.26V88.49h-4.33V85.91Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.39,79.31V95H230.3V88.44h-7.48V95h-3.09V79.31h3.09V85.6h7.48V79.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.82,82.08h-4.95V95h-3.11V82.08h-4.95V79.31h13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.46,31.77c0,5.47-8,5.47-8,0s8-5.46,8,0m-7.4,36.37h6.79V39.66H67.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.38,68.14V53.29c0-4.31-2.28-7.59-6.62-7.59-4.17,0-7,3.62-7,7.94v14.5H77V39.71h6.06l.45,3.86c2.78-2.82,5.56-4.26,9-4.26,6.45,0,11.62,5,11.62,13.93v14.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.13,47.31a9.07,9.07,0,0,0-6.79-2.53c-3.22,0-5,1-5,2.82s1.61,2.88,5.12,3.11c5.17.34,11.73,1.55,11.73,9.09,0,5-4,9.32-11.79,9.32-4.34,0-8.68-.75-12.68-5.06l3.34-5c1.94,2.24,6.39,3.91,9.45,4,2.56.06,4.95-1.32,4.95-3.4s-1.56-2.76-5.45-3c-5.17-.4-11.35-2.36-11.35-8.8S113.23,39,118.23,39c4.29,0,7.51.86,10.68,3.74Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.75,80V39.77h6.34l.45,3.92a10.74,10.74,0,0,1,8.89-4.55c8.46,0,14.08,6.5,14.08,14.85s-5.06,14.84-13.85,14.84c-2.9,0-7.18-.92-9.12-4V80Zm23-26c0-4.44-2.89-8.06-7.79-8.06s-7.78,3.62-7.78,8.06a7.79,7.79,0,1,0,15.57,0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.13,31.77c0,5.47-8,5.47-8,0s8-5.46,8,0m-7.4,36.37h6.79V39.66h-6.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.14,39.77l.5,3.28c2.11-3.51,5-4,7.73-4a10.21,10.21,0,0,1,7.07,2.71l-3.06,6.1a6.65,6.65,0,0,0-4.9-1.84c-3.56,0-6.84,1.95-6.84,7.19v15h-6.79V39.77Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201,56.46c.44,3.51,3.39,6,8.17,6,2.51,0,5.79-1,7.35-2.64l4.33,4.43c-2.89,3.1-7.62,4.6-11.79,4.6-9.45,0-15.07-6-15.07-15.13,0-8.64,5.67-14.85,14.57-14.85,9.18,0,14.91,5.87,13.85,17.55Zm14.9-5.81c-.44-3.68-3.22-5.53-7.12-5.53-3.67,0-6.67,1.85-7.67,5.53Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightLogo);
export default __webpack_public_path__ + "static/media/insight-logo.533e1edffb2644058053a725bc92a512.svg";
export { ForwardRef as ReactComponent };